import { FieldBuilder } from './FieldBuilder';
import { IFormControlDefinition } from './types';

export default class FormBuilder<T, K extends keyof T = keyof T> {

    public for(key: K & string, label: string, options: { description?: string } = {}): FieldBuilder<T> {
        return new FieldBuilder<T>(key, label, options);
    }
    public none(key: K & string): IFormControlDefinition<void> {
        return new FieldBuilder<T>(key, key).hidden();
    }
}



